import Form from './Form'
import Card from './Card'
import Row from './Row'
import Group from './Group'
import CollapseAction from './CollapseAction'
import TooltipAction from './TooltipAction'

export default {
    install(Vue) {

        Vue.component(Form.name, Form);
        Vue.component(Card.name, Card);
        Vue.component(Row.name, Row);
        Vue.component(Group.name, Group);
        Vue.component(CollapseAction.name, CollapseAction);
        Vue.component(TooltipAction.name, TooltipAction);

    }
}